import { useDispatch } from 'react-redux';
import { useAccount } from 'wagmi';
import { actionShowModal } from '../../../actions/modal';
import { formatAddress } from '../../../helpers/formatters';
import { ModalTypes } from '../../../reducers/modal';
import walletAdd from '../../../assets/images/wallet_add.svg';
import wallet from '../../../assets/images/wallet_grey.svg';
import NavItem from './NavItem';
import { useWallet } from '../../../wallet/walletContext';

const MobileWallet = () => {
  const { address: account } = useAccount();
  const dispatch = useDispatch();
  const { isConnected } = useWallet();

  return (
    <NavItem
      onClick={() => dispatch(actionShowModal(ModalTypes.connect, {}))}
      icon={isConnected ? wallet : walletAdd}
      active={!isConnected}
      navy={true}
      title={account ? formatAddress(account) : 'Connect wallet'}
    />
  );
};
export default MobileWallet;
